module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_success-ec3380d571501279b6705750a6b74400.svg";